(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["c_article-block-media"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.c_c-article-block--media video').forEach(function (v) {
    v.setAttribute('preload', 'auto');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["c_gallery-modal"] && !Shopify.designMode) return;
  try {
    (function () {
  /**
   * GalleryModal — 無限ループスライダー付きギャラリーモーダル
   *
   * クローンスライド方式:
   *   [clone-last] [slide-0] [slide-1] ... [slide-n] [clone-first]
   *   trackPosition = (current + 1) で実スライドを表示
   *   端に到達 → クローンへアニメーション → transitionend で実スライドへ瞬間移動
   */
  class GalleryModal {
    constructor(dialog) {
      this.dialog = dialog;
      this.track = dialog.querySelector('[data-gallery-track]');
      this.slides = Array.from(dialog.querySelectorAll('[data-gallery-slide]'));
      this.prevBtn = dialog.querySelector('[data-gallery-prev]');
      this.nextBtn = dialog.querySelector('[data-gallery-next]');
      this.currentEl = dialog.querySelector('[data-gallery-current]');
      this.totalEl = dialog.querySelector('[data-gallery-total]');
      this.total = this.slides.length;
      this.current = 0;
      this._isTransitioning = false;

      // タッチ
      this._touchStartX = 0;
      this._touchDeltaX = 0;
      this._isSwiping = false;

      if (this.totalEl) this.totalEl.textContent = this.total;

      // クローンスライドを生成（2枚以上の場合のみ）
      this._hasClones = this.total > 1;
      if (this._hasClones) {
        this._createClones();
      }

      this._bindEvents();
    }

    /**
     * 先頭と末尾にクローンスライドを追加
     * 結果: [clone-last] [real-0] [real-1] ... [real-n] [clone-first]
     */
    _createClones() {
      var firstClone = this.slides[0].cloneNode(true);
      var lastClone = this.slides[this.total - 1].cloneNode(true);
      firstClone.setAttribute('aria-hidden', 'true');
      lastClone.setAttribute('aria-hidden', 'true');
      firstClone.removeAttribute('data-gallery-slide');
      lastClone.removeAttribute('data-gallery-slide');
      this.track.appendChild(firstClone);
      this.track.insertBefore(lastClone, this.track.firstChild);
    }

    /**
     * trackのtranslateX位置を計算
     * クローンありの場合: position = current + 1（先頭クローン分のオフセット）
     * クローンなしの場合: position = current
     */
    _getTrackPosition(index) {
      return this._hasClones ? index + 1 : index;
    }

    _bindEvents() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());

      this.dialog.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.prev(); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.next(); }
      });

      // 画像・ナビ・閉じるボタン以外のクリックで閉じる
      this.dialog.addEventListener('click', (e) => {
        var target = e.target;
        if (target.closest('[data-gallery-prev]') || target.closest('[data-gallery-next]') || target.closest('[data-gallery-close]') || target.tagName === 'IMG') return;
        this.close();
      });

      this.dialog.querySelectorAll('[data-gallery-close]').forEach((btn) => {
        btn.addEventListener('click', () => this.close());
      });

      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('has-gallery-modal');
      });

      // transitionend でクローン→実スライドへ瞬間移動
      if (this._hasClones) {
        this.track.addEventListener('transitionend', () => this._onTransitionEnd());
      }

      // タッチイベント
      this.track.addEventListener('touchstart', (e) => this._onTouchStart(e), { passive: true });
      this.track.addEventListener('touchmove', (e) => this._onTouchMove(e), { passive: false });
      this.track.addEventListener('touchend', () => this._onTouchEnd());
    }

    open(index) {
      this.current = Math.max(0, Math.min(index || 0, this.total - 1));
      this._moveTrack(false);
      this._updateCounter();
      document.documentElement.classList.add('has-gallery-modal');
      this.dialog.showModal();
    }

    close() {
      this.dialog.close();
    }

    prev() {
      if (this._isTransitioning) return;

      if (this._hasClones) {
        // 無限ループ: current を1つ減らしてアニメーション
        this.current--;
        if (this.current < 0) {
          // -1 → クローン（先頭の clone-last）へアニメーション
          // transitionend で実スライド末尾へ瞬間移動
          this._isTransitioning = true;
          this._setTrackPos(0, true); // clone-last の位置
          this._updateCounter(this.total - 1);
          return;
        }
      } else {
        this.current = Math.max(this.current - 1, 0);
      }

      this._moveTrack(true);
      this._updateCounter();
    }

    next() {
      if (this._isTransitioning) return;

      if (this._hasClones) {
        this.current++;
        if (this.current >= this.total) {
          // total → クローン（末尾の clone-first）へアニメーション
          this._isTransitioning = true;
          this._setTrackPos(this.total + 1, true); // clone-first の位置
          this._updateCounter(0);
          return;
        }
      } else {
        this.current = Math.min(this.current + 1, this.total - 1);
      }

      this._moveTrack(true);
      this._updateCounter();
    }

    goTo(index) {
      if (this._isTransitioning) return;
      this.current = Math.max(0, Math.min(index, this.total - 1));
      this._moveTrack(true);
      this._updateCounter();
    }

    /**
     * transitionend: クローン位置から実スライドへ瞬間移動
     */
    _onTransitionEnd() {
      if (!this._isTransitioning) return;
      this._isTransitioning = false;

      if (this.current < 0) {
        // clone-last → 実スライド末尾
        this.current = this.total - 1;
      } else if (this.current >= this.total) {
        // clone-first → 実スライド先頭
        this.current = 0;
      }

      this._moveTrack(false);
    }

    /**
     * 実スライドのインデックスに基づいてトラックを移動
     */
    _moveTrack(animate) {
      var pos = this._getTrackPosition(this.current);
      this._setTrackPos(pos, animate);
    }

    /**
     * 任意の位置にトラックを移動（クローン含む絶対位置）
     */
    _setTrackPos(position, animate) {
      if (!this.track) return;
      this.track.style.transitionDuration = animate ? '' : '0ms';
      this.track.style.transform = 'translateX(-' + (position * 100) + '%)';
    }

    _updateCounter(displayIndex) {
      if (!this.currentEl) return;
      var idx = typeof displayIndex === 'number' ? displayIndex : this.current;
      // 0-based → 1-based、範囲を正規化
      this.currentEl.textContent = ((idx % this.total) + this.total) % this.total + 1;
    }

    // --- タッチスワイプ ---
    _onTouchStart(e) {
      if (this._isTransitioning) return;
      this._touchStartX = e.touches[0].clientX;
      this._touchDeltaX = 0;
      this._isSwiping = true;
      this.track.style.transitionDuration = '0ms';
    }

    _onTouchMove(e) {
      if (!this._isSwiping) return;
      this._touchDeltaX = e.touches[0].clientX - this._touchStartX;
      var pos = this._getTrackPosition(this.current);
      var swipePercent = (this._touchDeltaX / this.dialog.clientWidth) * 100;
      this.track.style.transform = 'translateX(' + (-(pos * 100) + swipePercent) + '%)';
      if (Math.abs(this._touchDeltaX) > 10) e.preventDefault();
    }

    _onTouchEnd() {
      if (!this._isSwiping) return;
      this._isSwiping = false;
      var threshold = this.dialog.clientWidth * 0.2;
      if (this._touchDeltaX > threshold) {
        this.prev();
      } else if (this._touchDeltaX < -threshold) {
        this.next();
      } else {
        this._moveTrack(true);
      }
    }
  }

  // --- トリガーのセットアップ ---
  function initGalleryModals() {
    var dialogs = document.querySelectorAll('[data-gallery-modal]');
    dialogs.forEach(function (dialog) {
      if (dialog._galleryInstance) return;
      var instance = new GalleryModal(dialog);
      dialog._galleryInstance = instance;

      var triggers = document.querySelectorAll('[data-gallery-open="' + dialog.id + '"]');
      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var index = parseInt(trigger.getAttribute('data-gallery-index') || '0', 10);
          instance.open(index);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryModals);
  } else {
    initGalleryModals();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["c_tab-collections-switcher"] && !Shopify.designMode) return;
  try {
    class TabCollections extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      const section = this.closest('.shopify-section');
      this.moreViewItems = section
        ? Array.from(section.querySelectorAll('[data-tab-more-view]')).map((el) => ({
            el,
            blockId: el.getAttribute('data-tab-more-view'),
          }))
        : [];
      this.activeIndex = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index), { signal });
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, index), { signal });
      });
    }

    disconnectedCallback() {
      if (this.abortController) this.abortController.abort();
    }

    activate(index) {
      if (this.activeIndex === index) return;
      this.activeIndex = index;

      const activePanel = this.panels[index];
      const activeBlockId = activePanel ? activePanel.getAttribute('data-tab-block-id') : null;

      this.tabs.forEach((tab, i) => {
        const isActive = i === index;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
        if (this.panels[i]) {
          this.panels[i].toggleAttribute('hidden', !isActive);
        }
      });

      this.moreViewItems.forEach(({ el, blockId }) => {
        el.toggleAttribute('hidden', blockId !== activeBlockId);
      });
    }

    handleKeydown(event, currentIndex) {
      const lastIndex = this.tabs.length - 1;
      let target = -1;

      switch (event.key) {
        case 'ArrowRight':
          target = currentIndex === lastIndex ? 0 : currentIndex + 1;
          break;
        case 'ArrowLeft':
          target = currentIndex === 0 ? lastIndex : currentIndex - 1;
          break;
        case 'Home':
          target = 0;
          break;
        case 'End':
          target = lastIndex;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.activate(target);
      this.tabs[target].focus();
    }
  }

  if (!customElements.get('tab-collections')) {
    customElements.define('tab-collections', TabCollections);
  }
  } catch(e) { console.error(e); }
})();

})();
